import React from 'react';
import { 
    Card,
    Image,
    Text,
    Group,
    Badge,
    createStyles,
    Center,
    Button,
    ActionIcon,
    Table
} from '@mantine/core';
import {
    IconGavel,
    IconHourglass,
    IconHeartPlus,
    IconHeart,
    IconEye,
    IconBell
} from '@tabler/icons';
import { ResponsiveCarouselCard } from './ResponsiveCarouselCard';
const useStyles = createStyles((theme) => ({
    cardContain: {
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
        width: 'inherit'
    },

    imageSection: {
        padding: theme.spacing.md,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        /*borderBottom: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
        }`,*/
    },
    
    label: {
        marginBottom: theme.spacing.xs,
        lineHeight: 1,
        fontWeight: 700,
        fontSize: theme.fontSizes.xs,
        letterSpacing: -0.25,
        textTransform: 'uppercase',
    },

    section: {
        padding: theme.spacing.md,
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
        }`,
    },
    subSection: {
        borderBottom: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
        }`,
    },

    icon: {
        marginRight: 5,
        color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[5],
    },
    detCols: {
        backgroundColor: 'grey'
    },
    tableStyle: {
        overflowX: "auto",
        whiteSpace: "nowrap",
    }
}));

//leaving the table header out because 
//needed: props
/*
 * car_make_0
 * car_model_0
 * mileage_1
 * vin_0
 * title_status_0
 * location_0
 * engine_0
 * drivetrain_0
 * ext_color_0
 * interiror_color_0
 * */
export function CarCardDetsTable() {
  const { classes } = useStyles();

    return (
        <Card withBorder radius="md" className={classes.cardContain}>
            <div className={classes.tableStyle}>
                <Table withBorder>
                    <tbody className={classes.tableStyle}>
                        <tr>
                            <td className={classes.detCols}>
                            Make
                            </td>
                            <td>
                            Pagani
                            </td>
                            <td className={classes.detCols}>
                            Model
                            </td>
                            <td>
                            Huayra
                            </td>
                        </tr>
                        <tr>
                            <td className={classes.detCols}>
                            Mileage
                            </td>
                            <td>
                            5,000
                            </td>
                            <td className={classes.detCols}>
                            VIN
                            </td>
                            <td>
                            123SDFKLJA9234453
                            </td>
                        </tr>
                        <tr>
                            <td className={classes.detCols}>
                            Title Status
                            </td>
                            <td>
                            clean
                            </td>
                            <td className={classes.detCols}>
                            Location
                            </td>
                            <td>
                            Pittsburgh, PA
                            </td>
                        </tr>
                        <tr>
                            <td className={classes.detCols}>
                            Engine
                            </td>
                            <td>
                            Twin Turbo V12
                            </td>
                            <td className={classes.detCols}>
                            Drivetrain
                            </td>
                            <td>
                            AWD
                            </td>
                        </tr>
                        <tr>
                            <td className={classes.detCols}>
                            Exterior Color
                            </td>
                            <td>
                            Black
                            </td>
                            <td className={classes.detCols}>
                            Interior Color
                            </td>
                            <td>
                            Black w/Green Accents
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        </Card>
    );
}
